<template>
  <div class="order-content">
    <div class="head-title">
      <h2 style="font-weight: 500;">
        <span style="position: absolute; top: 5px; left: 10px;" @click="re_back">
          <img src="../../static/return.png" style="width: 20px; height: 20px;" alt="">
        </span>
        <span style="font-size: 20px; line-height: 50px;">
          实 物 预 定 订 单
          <img style="width: 20px; height: 20px; position: relative; top: 4px; right: -22%;" src="../../static/tixians.png" alt=""  @click="handleWithdraw">
        </span>
      </h2>
    </div>
    <div class="head-balance">
      <div style="font-size: 14px">可用货款</div>
      <div class="usable-price">{{userInfo.accountBalance }} 元</div>
    </div>
    <div style="background-color: #F1F1F1;">
      <div class="t-trs" style="width: 100%; color: rgb(255, 255, 255); --darkreader-inline-color: #e8e6e3;">
        <div class="main-trs-other" style="width: 90%; margin: auto; border-bottom: 1px solid rgb(204, 204, 204); --darkreader-inline-border-bottom: #3e4446;">
          <div class="t-th-order">选择商品</div>
          <div class="t-th-order">回购价</div>
          <div class="t-th-order">销售价</div>
          <div class="t-th-order">高/低</div>
        </div>
      </div>
      <div style="width: 100%; background-color: rgb(255, 255, 255); --darkreader-inline-bgcolor: #181a1b;">
        <div class="t-tr-sea" style="width: 90%; margin: auto; height: 50px; border-bottom: 1px solid rgb(204, 204, 204); --darkreader-inline-border-bottom: #3e4446;">
          <div class="t-td-other" style="color: rgb(0, 0, 0); --darkreader-inline-color: #e8e6e3;">
            {{getItemName()}}
            <div style="margin-left: 4px"><RoundCheckbox /></div>
          </div>
          <div class="t-td-other" :style="dynamicColor['Sell']">
            {{ dynamicPrice['Sell'] }}
          </div>
          <div class="t-td-other" :style="dynamicColor['Sell']">
            {{ dynamicPrice['Buy'] }}
          </div>
          <div class="t-td-other-app">
            <div style="color: rgb(218, 10, 24); --darkreader-inline-color: #f63643; height: 50%;">
              {{ dynamicPrice['H'] }}
            </div>
            <div style="color: rgb(2, 187, 93); --darkreader-inline-color: #4afda2; height: 50%">
              {{ dynamicPrice['L'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gold-weight">
      <div style="display: flex; margin-left: 27px; margin-top: 15px; width: 100% !important;">
        预定克重(克)
        <div style="border: 1px solid rgb(204, 204, 204); display: flex; width: 60%; justify-content: space-between; margin-left: 5px;">
          <button style="font-size: 22px; background-color: white;border: none;" @click="decrease">-</button>
          <input type="text" style="border: none;background-color: rgb(255, 255, 255); width: 100px; text-align: center; color: rgb(0, 0, 0); font-size: 15px; margin-top: 4px;" v-model="orderParams.goldWeight" readonly onfocus="this.blur();" onmousedown="return false;" />
          <button style="margin-left: 2px; font-size: 22px; background-color: white;border: none;" @click="increase">+</button>
        </div>
      </div>
    </div>
    <div style="width: 85%; margin: 5px auto;">
      <div style="font-size: 17px; display: flex; justify-content: space-between; padding: 2px 0;">
        <div style="font-size: 16px;">预定定金</div>
        <div style="font-size: 16px;">{{orderParams.amount}}</div>
      </div>
      <div style="font-size: 17px; display: flex; justify-content: space-between; padding: 2px 0;">
        <div style="font-size: 16px;">可用货款</div>
        <div style="font-size: 16px;">{{parseInt(userInfo.accountBalance) - parseInt(orderParams.amount)}}</div>
      </div>
    </div>
    <div class="app-order-footer">
      <el-button
          :style="{
        backgroundColor: this.direction === 'Buy' ? 'rgb(242, 108, 107)' : this.direction === 'Sell' ? 'rgb(2, 187, 93)' : '',
        borderRadius: '32px',
        width: '85%',
        fontSize: '14px',
        color: '#fff'
      }" @click="orderSettlement">
        {{ this.direction === 'Buy' ? '预定价买料' : this.direction === 'Sell' ? '预定价卖料' : '' }}
      </el-button>
    </div>
    <div style="width: 85%; margin: 7px auto 25px; font-size: 11px; border-top: 1px solid rgb(204, 204, 204);">
      温馨提示：订单定金不足50%，需及时补足定金，定金不足0.01%系统自动对本单结算。
    </div>

    <el-dialog :visible.sync = "syncWithdrawOpen" width="90%">
      <div class="drawer-main" style="border-radius: 10px; top: 15%; height: 300px; background-color: rgb(255, 255, 255); --darkreader-inline-bgcolor: #181a1b; ">
        <div style="height: 180px">
          <div style="font-size: 20px; width: 100%; text-align: center; padding-top: 20px; color: black; font-weight: bold" >回款</div>
          <div style="font-size: 14px; color: black; margin-left: 5%">回款信息确认：</div>
          <div class="dialog-head-withdraw" style="width: 85%">
            <div style="color:black;">回款信息:</div>
            <div style="margin-left: 5px"><input maxlength="140" enterkeyhint="done" autocomplete="off" class="dialog-input-input" placeholder="请输入回款信息" v-model="withdrawParams.amount"/></div>
          </div>
          <div class="dialog-head-withdraw" style="width: 85%">
            <div style="color:black;">附言:</div>
            <div style="margin-left: 5px"><input maxlength="140" enterkeyhint="done" autocomplete="off" class="dialog-input-input" placeholder="选填" v-model="withdrawParams.postscript"/></div>
          </div>
          <div class="dialog-head-withdraw" style="width: 85%">
            <div style="color:black;">回款时间:</div>
            <div style="margin-left: 5px; width: 50%;"><input style="font-size: 8px" maxlength="180" enterkeyhint="done" autocomplete="off" class="dialog-input-input" v-model="withdrawParams.defaultText" readonly/></div>
          </div>
        </div>
        <div style="line-height: 45px; width: 100%; text-align: center; color: black; font-size: 14px">以上信息无误请确认</div>
        <div class="app-dialog-button">
          <div style="width: 50%;"><el-button style="margin-left: 50%; background-color: #ccc; border: 1px solid #ccc;" size="medium" type="primary"  @click="cancel">取消</el-button></div>
          <div style="width: 50%;"><el-button style="margin-left: 20%" size="medium" type="primary" @click="withdrawSubmit">确认</el-button></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync = "syncOrderOpen" width="90%">
      <div class="drawer-main" style="border-radius: 10px; top: 15%; height: 380px; background-color: rgb(255, 255, 255); --darkreader-inline-bgcolor: #181a1b; ">
        <div style="height: 255px;">
            <div style="text-align: center; font-size: 20px; padding-top: 20px; width: 100%; color: black">{{ this.direction === 'Buy' ? '预定价买料' : this.direction === 'Sell' ? '预定价卖料' : '' }}</div>
          <div class="dialog-head" style="padding-top: 10px">
            <div style="color: #666666">订单类型:</div>
            <div style="color: black">{{formatOrderType()}}</div>
          </div>
          <div class="dialog-head" style="padding-top: 10px">
            <div style="color: #666666">订单时间:</div>
            <div style="color: black">{{getToday()}}</div>
          </div>
          <div class="dialog-head" style="padding-top: 10px">
            <div style="color: #666666">预定金重:</div>
            <div style="color: rgb(0, 122, 255);">{{orderParams.goldWeight}}g</div>
          </div>
          <div class="dialog-head" style="padding-top: 10px">
            <div style="color: #666666">预定定金:</div>
            <div style="color: black">{{orderParams.amount}}</div>
          </div>
          <div class="dialog-head" style="padding-top: 10px">
            <div style="color: #666666">预定价格:</div>
            <div style="color: #00FF00">{{dynamicPrice[this.direction]}}</div>
          </div>
        </div>
        <div style="width: 90%; margin: auto; font-size: 14px; color: black; margin-top: 2px">温馨提示：订单定金不足50%，需及时补足定金，定金不足0.01%系统自动对本单结算。</div>
        <div style="width: 90%; margin: auto; color: black;">请确认以上信息无误</div>
        <div class="app-dialog-button">
          <div style="width: 50%;"><el-button style="margin-left: 60%; background-color: #666666; border: 1px solid #ccc;" size="medium" type="primary"  @click="cancel">取消</el-button></div>
          <div style="width: 50%;"><el-button style="margin-left: 30%" size="medium" type="primary" @click="createOrder">确认</el-button></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {EventBus} from '../common/eventBus'
import RoundCheckbox from './RoundCheckbox.vue'

export default {
  name: 'Order',
  components: {
    RoundCheckbox
  },
  data () {
    return {
      userInfo: {},
      tableList: [],
      type: '黄金板料',
      direction: 'Buy',
      syncWithdrawOpen: false,
      withdrawParams: {
        amount: '',
        postscript: '',
        defaultText: '周一至周五早上10点到下午3点'
      },
      dynamicColor: {},
      dynamicPrice: {},
      orderParams: {
        goldWeight: '1000',
        amount: '',
        type: '',
        direction: ''
      },
      syncOrderOpen: false,
      isCreatingOrder: false,
      isWithdraw: false
    }
  },
  created () {
    this.type = localStorage.getItem('type')
    this.direction = localStorage.getItem('direction')
    if (!this.GLOBAL.socket || this.GLOBAL.socket.readyState !== WebSocket.OPEN) {
      this.connectWebSocket()
    }
    EventBus.$on('tabListUpdated', updatedTabList => {
      this.tableList = updatedTabList
      this.updateDynamicData()
    })
    this.getUserInfo()
    localStorage.setItem('page', 'Order')
  },
  methods: {
    getUserInfo () {
      this.$api.userInfo().then(response => {
        if (response.code === 200) {
          this.userInfo = response.data
          this.orderParams.amount = parseInt(this.orderParams.goldWeight) * parseInt(this.userInfo.goldDepositRate)
        } else {
          this.msgError(response.msg)
        }
      })
    },
    re_back () {
      this.$router.push({ name: this.direction })
    },
    handleWithdraw () {
      this.syncWithdrawOpen = true
      this.withdrawParams.amount = ''
      this.withdrawParams.explanation = ''
    },
    cancel () {
      this.syncWithdrawOpen = false
      this.withdrawParams = {
        amount: '',
        explanation: '',
        defaultText: '周一至周五早上10点到下午3点'
      }
      this.syncOrderOpen = false
    },
    withdrawSubmit () {
      if (this.isWithdraw) {
        return
      }
      this.isWithdraw = true

      this.$api.withdraw(this.withdrawParams).then(response => {
        if (response.code === 200) {
          this.syncWithdrawOpen = false
          this.withdrawParams.amount = ''
          this.withdrawParams.explanation = ''
          this.withdrawParams.defaultText = '周一至周五早上10点到下午3点'
          this.msgSuccess(response.msg)
          this.getUserInfo()
        } else {
          this.msgError(response.msg)
        }
      })

      setTimeout(() => {
        this.isWithdraw = false
      }, 3000)
    },
    getItemName () {
      return this.type.substring(0, 2)
    },
    updateDynamicData () {
      this.dynamicColor = {
        'Buy': this.handleColor(),
        'Sell': this.handleColor()
      }
      this.dynamicPrice = {
        'Buy': this.handlePrice('Sell'),
        'Sell': this.handlePrice('Buy'),
        'H': this.handlePrice('H'),
        'L': this.handlePrice('L')
      }
    },
    handleColor () {
      let price = ''
      let maxPrice = ''
      let minPrice = ''
      if (!this.tableList) {
        return ''
      }
      switch (this.type) {
        case '黄金板料':
          if (this.tableList.hasOwnProperty('GOLD')) {
            price = parseFloat(this.tableList['GOLD'].Sell)
            minPrice = parseFloat(this.tableList['GOLD'].L)
            maxPrice = parseFloat(this.tableList['GOLD'].H)
          }
          break
        case '钯金板料':
          if (this.tableList.hasOwnProperty('PALLADIUM')) {
            price = parseFloat(this.tableList['PALLADIUM'].Sell)
            minPrice = parseFloat(this.tableList['PALLADIUM'].L)
            maxPrice = parseFloat(this.tableList['PALLADIUM'].H)
          }
          break
        case '铂金板料':
          if (this.tableList.hasOwnProperty('PLATINUM')) {
            price = parseFloat(this.tableList['PLATINUM'].Sell)
            minPrice = parseFloat(this.tableList['PLATINUM'].L)
            maxPrice = parseFloat(this.tableList['PLATINUM'].H)
          }
          break
      }
      let mid = (parseFloat(maxPrice) + parseFloat(minPrice)) / 2
      return parseFloat(price) > mid ? 'color:red;' : parseFloat(price) < mid ? 'color:#02BB5D' : ''
    },
    handlePrice (ty) {
      let price = ''
      if (!this.tableList) {
        return '--'
      }
      switch (this.type) {
        case '黄金板料':
          if (this.tableList.hasOwnProperty('GOLD')) {
            if (ty === 'Buy') {
              price = this.tableList['GOLD'].Buy
            } else if (ty === 'Sell') {
              price = this.tableList['GOLD'].Sell
            } else if (ty === 'H') {
              price = this.tableList['GOLD'].H
            } else if (ty === 'L') {
              price = this.tableList['GOLD'].L
            }
          }
          break
        case '钯金板料':
          if (this.tableList.hasOwnProperty('PALLADIUM')) {
            if (ty === 'Buy') {
              price = this.tableList['PALLADIUM'].Buy
            } else if (ty === 'Sell') {
              price = this.tableList['PALLADIUM'].Sell
            } else if (ty === 'H') {
              price = this.tableList['PALLADIUM'].H
            } else if (ty === 'L') {
              price = this.tableList['PALLADIUM'].L
            }
          }
          break
        case '铂金板料':
          if (this.tableList.hasOwnProperty('PLATINUM')) {
            if (ty === 'Buy') {
              price = this.tableList['PLATINUM'].Buy
            } else if (ty === 'Sell') {
              price = this.tableList['PLATINUM'].Sell
            } else if (ty === 'H') {
              price = this.tableList['PLATINUM'].H
            } else if (ty === 'L') {
              price = this.tableList['PLATINUM'].L
            }
          }
          break
      }
      return parseFloat(price) ? parseFloat(price).toFixed(2) : '--'
    },
    decrease () {
      if (parseInt(this.orderParams.goldWeight) === 1000) {
        return
      }
      this.orderParams.goldWeight = (parseInt(this.orderParams.goldWeight) - 1000).toString()
      this.orderParams.amount = parseInt(this.orderParams.goldWeight) * parseInt(this.userInfo.goldDepositRate)
    },
    increase () {
      if (parseInt(this.orderParams.goldWeight) === 10000) {
        return
      }
      this.orderParams.goldWeight = (parseInt(this.orderParams.goldWeight) + 1000).toString()
      this.orderParams.amount = parseInt(this.orderParams.goldWeight) * parseInt(this.userInfo.goldDepositRate)
    },
    orderSettlement () {
      this.syncOrderOpen = true
    },
    getToday () {
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const month = currentDate.getMonth() + 1
      const day = currentDate.getDate()
      const formattedMonth = month < 10 ? `0${month}` : month
      const formattedDay = day < 10 ? `0${day}` : day
      return `${year}-${formattedMonth}-${formattedDay}`
    },
    createOrder () {
      if (this.isCreatingOrder) {
        return
      }
      this.isCreatingOrder = true

      if (this.type === '黄金板料') {
        this.orderParams.type = '足金板料'
      } else {
        this.orderParams.type = this.type
      }
      if (this.direction === 'Buy') {
        this.orderParams.direction = '销售'
      } else {
        this.orderParams.direction = '回购'
      }
      this.$api.createOrder(this.orderParams).then(response => {
        if (response.code === 200) {
          this.msgSuccess('下单成功,请前往会员中心查看')
          this.syncOrderOpen = false
          this.orderParams.goldWeight = '1000'
          this.getUserInfo()
          this.orderParams.amount = parseInt(this.orderParams.goldWeight) * parseInt(this.userInfo.goldDepositRate)
          this.orderParams.type = ''
          this.orderParams.direction = ''
        } else {
          this.msgError(response.msg)
        }
      })

      setTimeout(() => {
        this.isCreatingOrder = false
      }, 3000)
    },
    formatOrderType () {
      if (this.type === '黄金板料' && this.direction === 'Buy') {
        return '预定价购买足金实物板料'
      }
      if (this.type === '黄金板料' && this.direction === 'Sell') {
        return '预定价卖出实物黄金'
      }
      if (this.type === '铂金板料' && this.direction === 'Buy') {
        return '预定价购买铂金实物板料'
      }
      if (this.type === '铂金板料' && this.direction === 'Sell') {
        return '预定价卖出实物铂金'
      }
      if (this.type === '钯金板料' && this.direction === 'Buy') {
        return '预定价购买钯金实物板料'
      }
      if (this.type === '钯金板料' && this.direction === 'Sell') {
        return '预定价卖出实物钯金'
      }
    }
  }
}
</script>

<style scoped>
.order-content {
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
}

.head-title {
  z-index: 999;
  width: 100%;
  background-color: #fdc800;
  margin-bottom: 10px;
}

.head-title h2 {
  text-align: center;
  font-size: 19px;
  color: #000;
  height: 50px;
  line-height: 50px;
  margin: 0;
  padding: 0;
}

.head-title h2 {
  width: 100%;
  text-align: center;
}

.head-balance {
  font-family: PingFang SC,serif;
  padding: 7px 0 7px;
  text-align: center;
  background-color: #FFFFFF;
  color: #000;
}

.usable-price {
  font-size: 18px;
}

.drawer-main{
  width: 90%;
  margin: auto;
  position: fixed;
  top: 15%;
  height: 60%;
  left: 5%;
  z-index: 992;
  border-radius: 10px;
}

.dialog-head{
  width: 90%;
  margin: auto;
  font-size: 15px;
  font-family: PingFang SC,serif;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  height: 27px;
  line-height: 27px;
}

.dialog-head-withdraw{
  width: 90%;
  margin: auto;
  font-size: 15px;
  font-family: PingFang SC,serif;
  display: flex;
  border-bottom: 1px solid #e6e6e6;
  height: 35px;
  line-height: 35px;
}

.dialog-input-input {
  width: 100%;
  border: none;
  background-color: rgb(255, 255, 255);
  --darkreader-inline-bgcolor: #181a1b;
  font-size: 15px;
  color: black;
}

.dialog-input-input:focus {
  outline: none;
}

.app-dialog-button{
  display: flex;
  justify-content: space-between;
}

.t-trs {
  background-color: #fff !important;
}

.t-trs .t-tr {
  background-color: #fff !important;
}

.main-trs-other {
  width: 100%;
  margin: auto;
  color: #FFFFFF;
  display: flex;
  height: 50px;
  line-height: 50px;

}

.main-trs-other .t-th-order {
  color: #666;
  border-top-color: initial !important;
  border-bottom-color: initial !important;
  line-height: 50px!important;
  font-size: 17px;
  width: 24%!important;
  font-family: PingFang SC,serif;
  font-weight: 700;
  border-top: none!important;
  border-bottom: none!important;
  margin-left: -1px;
  text-align: center!important;
}

.main-trs-other .t-th-order:first-child {
  width: 28% !important;
}

.t-tr-sea .t-td-other {
  width: 24%!important;
  line-height: 50px!important;
  font-size: 16px;
  font-family: PingFang SC,serif;
  border-top: none!important;
  border-bottom: none!important;
  margin-left: -1px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.t-tr-sea .t-td-other:first-child {
  width: 28% !important;
}

.t-td-other-app{
  line-height: 200%;
  font-size: 14px;
  width: 24%!important;
  font-family: PingFang SC,serif;
  border-top: none;
  border-bottom: none!important;
  margin-left: -1px;
  text-align: center;
}

.gold-weight {
  width: 100%;
  background-color: rgb(255, 255, 255);
  --darkreader-inline-bgcolor: #181a1b;
  font-size: 15px;
  margin: 5px auto 0;
}

.app-order-footer {
  margin-top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Order.vue